// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: icon("ic_blog"),
  cart: icon("ic_cart"),
  chat: icon("ic_chat"),
  mail: icon("ic_mail"),
  user: icon("ic_user"),
  file: icon("ic_file"),
  lock: icon("ic_lock"),
  label: icon("ic_label"),
  blank: icon("ic_blank"),
  kanban: icon("ic_kanban"),
  folder: icon("ic_folder"),
  banking: icon("ic_banking"),
  booking: icon("ic_booking"),
  invoice: icon("ic_invoice"),
  calendar: icon("ic_calendar"),
  disabled: icon("ic_disabled"),
  external: icon("ic_external"),
  menuItem: icon("ic_menu_item"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: "general",
  //   items: [
  //     { title: "app", path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
  //   ],
  // },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: "management",
    items: [
      {
        title: "Dashboards",

        path: PATH_DASHBOARD.dashboards.root,
        icon: ICONS.dashboard,
        children: [
          { title: "HQ Overview", path: PATH_DASHBOARD.dashboards.revenue, roles: ["admin"] },
          {
            title: "Summary",
            path: PATH_DASHBOARD.dashboards.distributor,
            roles: ["admin", "distributor", "referrer", "group_manager", "sub-distributor", "sub_distributor_manager", "sub_distributor_finance"],
          },
          {
            title: "Rewards",
            path: PATH_DASHBOARD.dashboards.craveRewards,
            roles: ["distributor"],
            distributors: ["Igougo (PTY) Ltd ta Crave"],
          },
          {
            title: "Promo Engine",
            path: PATH_DASHBOARD.dashboards.promoEngine,
            roles: ["distributor", "sub-distributor"],
            distributors: ["The SPAR Group Limited"],
          },
          {
            title: "Promo Engine Ledger",
            path: PATH_DASHBOARD.dashboards.promoEngineLedger,
            roles: ["distributor"],
            distributors: ["The SPAR Group Limited"],
          },
          {
            title: "Retail Commission",
            path: PATH_DASHBOARD.dashboards.retailCommission,
            roles: ["sub-distributor", "sub_distributor_manager", "sub_distributor_finance"],
            distributors: ["The SPAR Group Limited"],
          },
          { title: "Balances", path: PATH_DASHBOARD.dashboards.balances, roles: ["distributor", "sub-distributor"] },
          // {
          //   title: "Retail Incentive",
          //   path: PATH_DASHBOARD.dashboards.retailIncentive,
          //   roles: ["admin", "distributor", "sub-distributor", "sub_distributor_manager", "sub_distributor_finance"],
          //   distributors: ["The SPAR Group Limited"],
          // }
        ],
        roles: ["admin", "distributor", "referrer", "group_manager", "sub-distributor", "sub_distributor_manager", "sub_distributor_finance"],
      },
      // ADMIN
      {
        title: "Admin",
        path: PATH_DASHBOARD.admin.root,
        icon: ICONS.user,
        children: [
          { title: "Admin Users", path: PATH_DASHBOARD.admin.adminUsers, roles: ["admin"] },
          {
            title: "Portal Users",
            path: PATH_DASHBOARD.admin.appUsers,
            roles: ["admin", "distributor", "sub-distributor", "sub_distributor_manager", "sub_distributor_operations"],
          },
          { title: "Portal Notices", path: PATH_DASHBOARD.admin.distributorNotices, roles: ["admin", "distributor"] },
          { title: "Sub-Distributor Groups", path: PATH_DASHBOARD.admin.subDistributorGroups, roles: ["admin"] },
        ],
        roles: ["admin", "distributor", "sub-distributor", "sub_distributor_manager", "sub_distributor_operations"],
      },
      // DISTRIBUTORS
      {
        title: "Reports",
        path: PATH_DASHBOARD.distributors.root,
        icon: ICONS.user,
        children: [
          {
            title: "Transaction History",
            path: PATH_DASHBOARD.distributors.transactions,
            roles: ["admin", "finance", "distributor", "support_agent", "sub-distributor", "sub_distributor_manager", "sub_distributor_finance"],
          },
          // { title: "Dashboard", path: PATH_DASHBOARD.distributors.dashboard },
          // { title: "Graphs", path: PATH_DASHBOARD.distributors.graphs, roles: ["admin"] },

          ...(!window.location.href.includes("sparmobile")
            ? [
              {
                title: "Customers",
                path: PATH_DASHBOARD.distributors.statusList,
                roles: ["admin", "distributor"],
                distributors: ["Labour Market Activation Group (Pty) Ltd"],
              },
            ]
            : []),
          { title: "Sales Report", path: PATH_DASHBOARD.distributors.salesReport, roles: ["honey"] },
          { title: "Distributor Report", path: PATH_DASHBOARD.distributors.distributorReport, roles: ["admin", "distributor"] },
          { title: "Vouchers", path: PATH_DASHBOARD.distributors.voucherList, roles: ["admin", "distributor", "support_agent"] },
        ],
        roles: ["admin", "distributor", "honey", "support_agent", "sub-distributor", "sub_distributor_manager", "sub_distributor_finance", "finance"],
      },
      //  CUSTOMERS
      {
        title: "Customers",
        path: PATH_DASHBOARD.customers.root,
        icon: ICONS.user,
        children: [
          {
            title: "Search",
            path: PATH_DASHBOARD.customers.search,
            roles: ["admin", "distributor", "support_agent", "sub-distributor", "sub_distributor_manager"],
          },
        ],
        roles: ["admin", "distributor", "support_agent", "sub-distributor", "sub_distributor_manager"],
      },
      // Customer Care
      {
        title: "Customer Care",
        path: PATH_DASHBOARD.customerCare.root,
        icon: ICONS.cart,
        children: [
          { title: "port-in list", path: PATH_DASHBOARD.customerCare.portIn, roles: ["admin"] },
          { title: "Verify self RICA", path: PATH_DASHBOARD.customerCare.selfRicaList, roles: ["admin"] },
          { title: "SIM Swap", path: PATH_DASHBOARD.customerCare.simSwap, roles: ["admin"] },
          { title: "Customer Top-up", path: PATH_DASHBOARD.customerCare.topup, roles: ["admin"] },
          // {
          //   title: "Support Ticket Escalation",
          //   path: PATH_DASHBOARD.customerCare.escalation,
          //   roles: ["distributor", "sub-distributor", "support_agent", "sub_distributor_manager", "agent"],
          // },
          { title: "RICA Uplift Queue", path: PATH_DASHBOARD.customerCare.ricaUpliftQueue, roles: ["admin"] },
        ],
        // roles: ["admin", "sub_distributor_manager", "distributor", "sub-distributor", "support_agent", "agent"],
        roles: ["admin"],
      },
      // RICA & SELF RICA
      {
        title: "RICA / PORT",
        path: PATH_DASHBOARD.rica.root,
        icon: ICONS.cart,
        children: [
          // { title: "Verify self RICA", path: PATH_DASHBOARD.rica.selfRica, roles: ["admin"] },
          // { title: "Status list", path: PATH_DASHBOARD.rica.list, roles: ["admin"] },
          {
            title: "Rica Customer",
            path: `${PATH_DASHBOARD.rica.selfRicaForm}/agent_rica`,
            roles: ["admin", "distributor", "sub-distributor", "sub_distributor_manager", "honey", "support_agent", "agent"],
          },
          {
            title: "Pre Rica",
            path: `${PATH_DASHBOARD.rica.selfRicaForm}/pre_rica`,
            roles: ["admin"],
          },
          {
            title: "Port Customer",
            path: PATH_DASHBOARD.rica.port,
            roles: ["admin", "distributor", "sub-distributor", "honey", "support_agent", "agent", "sub_distributor_manager"],
          },
        ],
        roles: ["admin", "distributor", "sub-distributor", "honey", "support_agent", "agent", "sub_distributor_manager"],
      },
      // CX
      {
        title: "CX",
        path: PATH_DASHBOARD.cx.root,
        icon: ICONS.user,
        children: [
          { title: "Message Templates", path: PATH_DASHBOARD.cx.messaging.list },
          { title: "Notices", path: PATH_DASHBOARD.cx.notices.list },
        ],
        roles: ["admin"],
      },
      // Reports

      // {
      //   title: "Reports",
      //   path: PATH_DASHBOARD.reports.root,
      //   icon: ICONS.invoice,
      //   children: [{ title: "Reports", path: PATH_DASHBOARD.reports.list }],
      //   roles: ["admin"],
      // },

      // IOT
      {
        title: "IOT",
        path: PATH_DASHBOARD.iot.root,
        icon: ICONS.ecommerce,
        children: [
          { title: "Accounts", path: PATH_DASHBOARD.iot.list },
          { title: "Rules", path: PATH_DASHBOARD.iot.rules },
          // { title: "Usage", path: PATH_DASHBOARD.iot.usage },
        ],
        roles: ["iot"],
      },
      // SIM CARD OPERATIONS
      {
        title: "SIM Cards",
        path: PATH_DASHBOARD.simCards.root,
        icon: ICONS.ecommerce,
        children: [
          { title: "SIM Assignment", path: PATH_DASHBOARD.simCards.assignment, roles: ["admin"] },
          { title: "SIM Unassignment", path: PATH_DASHBOARD.simCards.unassignment, roles: ["admin"] },
          {
            title: "Scan Out SIM cards",
            path: PATH_DASHBOARD.simCards.scanOut,
            ...(window.location.href.includes("sparmobile")
              ? { roles: ["admin"] }
              : { roles: ["admin", "distributor"] }),
          },
          ...(window.location.href.includes("sparmobile")
            ? [
              {
                title: "Scan In SIM cards",
                path: PATH_DASHBOARD.simCards.scanOutRequests,
                roles: ["sub-distributor", "sub_distributor_manager", "sub_distributor_operations"],
                distributors: ["The SPAR Group Limited", "megsApp HQ"],
              },
            ]
            : [
              {
                title: "Scan In SIM cards",
                path: PATH_DASHBOARD.simCards.scanOut,
                roles: ["sub-distributor", "sub_distributor_manager", "sub_distributor_operations"],
              },
            ]),
          { title: "SIM Orders", path: PATH_DASHBOARD.simCards.orders, roles: ["admin", "finance"] },
          {
            title: "SIM Card Status",
            path: PATH_DASHBOARD.simCards.status,
            roles: ["admin", "distributor", "support_agent", "sub-distributor", "sub_distributor_manager", "sub_distributor_operations"],
          },
          {
            title: "Inner Box Status",
            path: PATH_DASHBOARD.simCards.innerBoxStatus,
            roles: ["admin", "distributor", "sub-distributor", "sub_distributor_manager"],
          },
        ],
        roles: ["admin", "distributor", "sub-distributor", "sub_distributor_manager", "sub_distributor_operations", "finance"],
      },
      // Resellers
      {
        title: "Airtime and Data",
        path: PATH_DASHBOARD.resellers.root,
        icon: ICONS.ecommerce,
        children: [
          { title: "Transactions", path: PATH_DASHBOARD.resellers.transactions, roles: ["distributor", "reseller"] },
          { title: "Allocate Airtime and Data", path: PATH_DASHBOARD.resellers.sellProduct, roles: ["distributor", "reseller"] },
        ],
        roles: ["distributor", "reseller"],
      },
      // Vouchers
      // {
      //   title: "Vouchers",
      //   path: PATH_DASHBOARD.vouchers.root,
      //   icon: ICONS.ecommerce,
      //   children: [{ title: "Vouchers", path: PATH_DASHBOARD.vouchers.list }],
      //   roles: ["admin", "support_agent"],
      // },
      // Wallets

      ...(!window.location.href.includes("sparmobile")
        ? [
          {
            title: "Wallets",
            path: PATH_DASHBOARD.wallets.root,
            icon: ICONS.ecommerce,
            children: [
              { title: "Account Bulk Payments", path: PATH_DASHBOARD.wallets.accountBulkPayments, roles: ["distributor", "sub-distributor"] },
              { title: "Wallet Bulk Payments", path: PATH_DASHBOARD.wallets.bulkPayments, roles: ["distributor", "sub-distributor"] },
              { title: "Batch Requests", path: PATH_DASHBOARD.wallets.batchRequest, roles: ["distributor", "sub-distributor"] },
              { title: "Merchant Accounts", path: PATH_DASHBOARD.wallets.merchantAccounts, roles: ["distributor", "sub-distributor"] },
              { title: "Wallet Reports", path: PATH_DASHBOARD.wallets.walletReports, roles: ["distributor"], distributors: ["Labour Market Activation Group (Pty) Ltd"] },
            ],
            roles: ["distributor", "sub-distributor"],
          },
        ]
        : []),

      {
        title: "Subscriptions",
        path: PATH_DASHBOARD.subscriptions.root,
        icon: ICONS.ecommerce,
        children: [
          { title: "Manage Subscriptions", path: PATH_DASHBOARD.subscriptions.manageSubscriptions, roles: ["distributor"] },
          { title: "Batch Requests", path: PATH_DASHBOARD.subscriptions.subscriptionRequests, roles: ["distributor"] },
          { title: "Active Subscriptions", path: PATH_DASHBOARD.subscriptions.activeSubscriptions, roles: ["admin", "distributor"] },
        ],
        roles: ["admin", "distributor"],
      },
      {
        title: "Products",
        path: PATH_DASHBOARD.products.root,
        icon: ICONS.ecommerce,
        children: [
          { title: "Product List", path: PATH_DASHBOARD.products.productList, roles: ["admin"] },
          { title: "Product Group", path: PATH_DASHBOARD.products.productGroupList, roles: ["admin"] },
        ],
        roles: ["admin"],
      },
      {
        title: "Webhooks",
        path: PATH_DASHBOARD.webhooks.root,
        icon: ICONS.ecommerce,
        children: [{ title: "Manage Webhooks", path: PATH_DASHBOARD.webhooks.manage, roles: ["distributor"] }],
        roles: ["distributor"],
      },
      {
        title: "Training Videos",
        path: PATH_DASHBOARD.trainingVideos.root,
        icon: ICONS.ecommerce,
        children: [
          { title: "Training Videos", path: PATH_DASHBOARD.trainingVideos.list, roles: ["admin"] },
          { title: "Add Training Videos", path: PATH_DASHBOARD.trainingVideos.addVideos, roles: ["admin"] },
          {
            title: "Agent Videos",
            path: PATH_DASHBOARD.trainingVideos.agentVideos,
            roles: ["admin", "distributor", "sub-distributor", "support_agent", "sub_distributor_manager", "agent"],
          },
          {
            title: "Consumer Videos",
            path: PATH_DASHBOARD.trainingVideos.consumerVideos,
            roles: ["admin", "distributor", "sub-distributor", "support_agent", "sub_distributor_manager", "agent"],
          },
        ],
        roles: ["admin", "distributor", "sub-distributor", "support_agent", "sub_distributor_manager", "agent"],
      },
      {
        title: "Sub-Distributors",
        path: PATH_DASHBOARD.subDistributors.list,
        icon: ICONS.ecommerce,
        roles: ["admin", "distributor"],
      },
      // {
      //   title: "Sub-Distributors Agreement",
      //   path: PATH_DASHBOARD.subDistributors.agreement,
      //   icon: ICONS.ecommerce,
      //   roles: ["admin", "distributor"],
      // },
      {
        title: "Rule-Management",
        path: PATH_DASHBOARD.ruleManagement.root,
        icon: ICONS.ecommerce,
        roles: ["admin", "distributor", "sub-distributor"],
        distributors: ["The SPAR Group Limited"],
        subDistributors : ["The SPAR Group Limited"],
        children: [
          {
            title: "Promo Rule Management",
            path: PATH_DASHBOARD.ruleManagement.promoRule,
            roles: ["admin", "distributor", "sub-distributor"],
            distributors: ["The SPAR Group Limited"],
            subDistributors : ["The SPAR Group Limited"],
          },
          {
            title: "Products",
            path: PATH_DASHBOARD.ruleManagement.product.root,
            roles: ["admin", "distributor", "sub-distributor"],
            distributors: ["The SPAR Group Limited"],
            subDistributors : ["The SPAR Group Limited"],
          },
        ],
      },
      {
        title: "Loyalty Reward ",
        roles: ["distributor"],
        path: PATH_DASHBOARD.rewardManagement.root,
        icon: ICONS.ecommerce,
        children: [
          {
            title: "Loyalty Reward Management",
            path: PATH_DASHBOARD.rewardManagement.list,
            roles: ["distributor"],
          },
        ],
      },
      // {
      //   title: "Distributor Self Service",
      //   path: PATH_DASHBOARD.selfService.order,
      //   icon: ICONS.ecommerce,
      //   children: [{ title: "Self Service", path: PATH_DASHBOARD.selfService.order, roles: ["sub-distributor"] }],
      //   roles: ["sub-distributor"],
      // },
    ],
  },
];

export default navConfig;
